import Yup from 'src/yup';

export const validations = Yup.object().shape({
  username: Yup.string().trim().required('Required'),
  firebaseId: Yup.string().trim().required('Required'),
  hostIds: Yup.string().required('Required'),
});
